import styled from 'styled-components';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { IconDocument, IconDownload } from '~/assets/svgs';

export const Container = styled.div`
  max-height: 30rem;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  color: ${({ theme }) => theme.colors.base[500]};
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
  line-height: normal;
`;

export const WrapperItems = styled(PerfectScrollbar)`
  width: 100%;
  height: 18rem;
`;

export const WrapperItem = styled.button`
  border: 1px solid rgba(198, 204, 210, 0.3);
  border-radius: 10px;
  height: 5rem;
  width: fit-content;
  padding-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem 0;
  background: transparent;
`;

export const WrapperDocument = styled.div`
  display: flex;
  background-color: #e8f1f8;
  border-radius: 5px;
  margin: 1.6rem;
  padding: 0.3rem 0.7rem;
`;

export const DocumentIcon = styled(IconDocument)`
  stroke: #0e067d;
  width: 2rem;
`;

export const WrapperDownload = styled.div`
  cursor: pointer;
  margin-right: 1rem;
`;

export const DownloadIcon = styled(IconDownload)`
  fill: #606474;
  width: 5rem;
`;

export const NoData = styled.span`
  font-size: 1.4rem;
  color: #b2b2b2;
`;
